import { style } from "@vanilla-extract/css";

import { theme } from "../../theme/css/theme.css";

export const inputsContainerStyle = style({
  width: "100%",
  maxWidth: "100%",
  selectors: {
    "&:empty": {
      display: "contents",
    },
  },
});

export const headerStyle = style({
  // paddingBottom: theme.spacings.s,
});

export const fieldSetStyle = style({
  width: "100%",
  maxWidth: "100%",
  borderRadius: theme.borderRadiuses.s,
  border: 0,
  selectors: {
    [`&:has(${inputsContainerStyle}:empty)`]: {
      display: "none",
    },
  },
});
